<div class="body-zone">
  <documents [application]="application"></documents>
  <vehicle-display class="desktop-only"></vehicle-display>
</div>
